import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import moment from 'moment';
import {
    setDateTimeFormatGlobal, setSeparatorsNumbersNew, settings, validateDecimals, getError, sendMessageCloseCurrentWindow,
    isUndNullEmpNew, getResponse, getLanguageObj
} from '../../helpers/UtilsHelper';
import { RateService } from '../../services/rates/RateService';
import { AuthContextType } from '../../auth/AuthContext';
import { RateClass } from '../../classes/rate/rateClass';
import { UserClass } from '../../classes/user/userClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { firebase, icons, images, labels, messages, numberPositions } = settings;
const { fields: dbFields } = firebase?.firestore || {};

const currentMethod = 'RateAddEdit - function';

export default function RateAddEdit({
    processValues = {},
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const {
        $ = {},
        auth = AuthContextType,
        user = UserClass?.getClass(),
        // setUser = () => { },
        users = [],
        rate = RateClass?.getClass(),
        setRate = () => { },
        applyTo = 0,
        setApplyTo = () => { },
        // rateAddEditDateTimeId = '',
        // modalId = '',
        showModal = false,
        setShowModal = () => { },
        type = 0,
        setType = () => { },
        getUserAndRatesData = ({
            e = {},
            userId = '',
            showMessage = true,
            subMethod = ''
        } = {}) => { },
        formName = '',
        setFormData = () => { },
        dtId = '',
        getNewPrice = ({
            priceOtherCurrency = 0.00,
            rate = 0.00,
            subMethod = '',
        } = {}) => { },
        setComparatorPrices = ({
            newPrice_ = 0.00,
            price_ = 0.00,
            subMethod = '',
        } = {}) => { },
    } = processValues;
    const [errors, setErrors] = useState({
        rate: '',
        register: '',
        applyTo: '',
    });
    const [selectOptions, setSelectOptions] = useState([]);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const isMount = useRef(true);
    const dateTimeFormat = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`;
    const controls = {
        pickers: {
            registerDate: {
                id: 'pickerRegisterDateId',
            }
        },
        inputs: {
            registerDate: {
                id: 'inputRegisterDateId',
            }
        },
    }
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        isModalClose = false,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDefaultValue';
        try {
            setErrors({
                rate: '',
                register: '',
                applyTo: '',
            });
            setType(0);
            setApplyTo(0);
            setShowModal(!isModalClose);
            setRate(prev => ({
                ...prev,
                id: '',
            }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
    };

    const addRate = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addRate';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const rate_ = response?.result?.rate || rate;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            const token = auth?.account?.tokenVzLaML?.token;

            if (applyTo === 1) {
                response = await RateService.save({
                    rate: {
                        ...rate_,
                        userId: user?.id,
                    },
                    token,
                    processType: 0,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            } else {
                const rateList = users.map((detail) => ({
                    userId: detail?.id,
                    rate: rate_?.rate,
                    register: rate_?.register,
                }));

                response = await RateService.saveList({
                    rateList: rateList,
                    token,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }

            switch (formName) {
                case 'Rates':
                    await getUserAndRatesData({
                        e: null,
                        userId: rate_?.userId,
                        showMessage: false,
                        subMethod: currentMethod,
                    });
                    break;
                case 'Items':
                    setFormData(prev => ({
                        ...prev,
                        rate: rate_?.rate,
                    }));


                    const dtIdLocal = $(`#${dtId}`).DataTable();
                    if (dtIdLocal?.rows()?.[0]?.length > 0) {
                        dtIdLocal?.rows()?.[0]?.forEach(function (rowIdx) {
                            const priceOtherCurrencyLocal = dtIdLocal.row(this).cell(rowIdx, 3).data();
                            const priceLocal = parseFloat(dtIdLocal.row(this).cell(rowIdx, 5).data());
                            const calculatedNewPrice = parseFloat(
                                getNewPrice({
                                    priceOtherCurrency: priceOtherCurrencyLocal,
                                    rate: rate_?.rate,
                                    subMethod: currentMethod,
                                })
                            );
                            const newPrice_ = `${setSeparatorsNumbersNew({
                                number: calculatedNewPrice,
                                withDecimals: true,
                                subMethod: currentMethod
                            })?.result} <i class='${setComparatorPrices({ newPrice_: calculatedNewPrice, price_: priceLocal, subMethod: currentMethod })}'></i>`;
                            dtIdLocal.row(this).cell(rowIdx, 4).data(newPrice_);
                        });
                    }
                    break;
                default:
                    break;
            }

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({
                    isModalClose: true,
                    subMethod: currentMethod,
                });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const editRate = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editRate';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (formName === 'Rates') {
                response = formDataValidate({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                const rate_ = response?.result?.rate || rate;

                setProcess(prev => ({ ...prev, showLoading: true, save: true }));

                const token = auth?.account?.tokenVzLaML?.token;

                if (applyTo === 1) {
                    response = await RateService.save({
                        rate: {
                            ...rate_,
                            userId: user?.id,
                        },
                        token,
                        processType: 1,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }

                await getUserAndRatesData({
                    e: null,
                    userId: rate_?.userId,
                    showMessage: false,
                    subMethod: currentMethod,
                });
            }

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({
                    isModalClose: true,
                    subMethod: currentMethod,
                });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const setFormValue = ({
        key = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormValue';
        let response = getResponse({ type: 0 });
        try {
            setRate(prev => ({
                ...prev,
                [key]: value,
            }));
            if (key === dbFields?.rate && value !== '') {
                setErrors(prev => ({ ...prev, rate: '' }));
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { rate: '', register: '', applyTo: '' };

            // const dateTime = $(`#${controls?.pickers?.registerDate?.id}`).val();
            const dateTime = $(`#${controls?.pickers?.registerDate?.id}`)?.datetimepicker('date')?._d;
            const dateTimeObj = moment(dateTime, dateTimeFormat);
            const rate_ = parseFloat(Number(rate?.rate).toFixed(numberPositions?.decimalsPlace));

            if (isUndNullEmpNew({ data: rate_, subMethod: currentMethod })?.result || isNaN(rate_)) {
                errors_.rate = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: dateTime, subMethod: currentMethod })?.result || !dateTimeObj.isValid()) {
                errors_.register = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (type === 0 && (isUndNullEmpNew({ data: applyTo, subMethod: currentMethod })?.result || applyTo === 0)) {
                errors_.applyTo = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);

            if (response?.isWarning) {
                response.isSuccess = false;
            } else {
                const updatedRate = {
                    ...rate,
                    rate: rate_,
                    register: dateTimeObj._d.toISOString(),
                };
                setRate(updatedRate);
                response.result = { rate: updatedRate };
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const changeApplyToValue = ({
        applyTo = '0',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeApplyToValue';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                applyTo: '',
            }));
            setApplyTo(parseInt(applyTo));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            if (showModal) {
                //#region old code
                // let registerDate = new Date();
                // if (!isUndNullEmpNew({ data: rate?.register, subMethod: currentMethod })?.result) {
                //     registerDate = new Date(rate.register);
                // }

                // //#region set dateTimePicker default values
                // $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                //     icons: settings?.react?.tempusDominus?.icons,
                //     buttons: settings?.react?.tempusDominus?.buttons,
                //     //tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                //     locale: 'es',
                // });
                // //#endregion set dateTimePicker default values


                // $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                //     icons: settings?.react?.tempusDominus?.icons,
                //     buttons: settings?.react?.tempusDominus?.buttons,
                //     tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                //     locale: languageObj?.id,
                // });

                // console.log('moment', moment(registerDate, dateTimeFormat));

                // const pickerElement = $(`#${controls?.pickers?.registerDate?.id}`);
                // if (pickerElement?.length > 0) {
                //     if (pickerElement.data('datetimepicker')) {
                //         pickerElement.datetimepicker('date', moment(registerDate, dateTimeFormat));
                //     } else {
                //         pickerElement.datetimepicker({
                //             date: moment(registerDate, dateTimeFormat),
                //             default: false,
                //             format: dateTimeFormat,
                //         });
                //     }
                // }

                // $(`#${controls?.pickers?.registerDate?.id}`).datetimepicker({
                //     date: moment(registerDate, dateTimeFormat),
                //     default: false,
                //     format: dateTimeFormat,
                // });
                //#endregion old code

                response = setDateInControl({
                    date: new Date(),
                    registerDate: rate?.register,
                    processType_: 0,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                const selectOptionsLocal = [
                    { id: 0, description: labels?.applyTo?.[languageObj?.id] },
                    { id: 1, description: labels?.thisUser?.[languageObj?.id] },
                    { id: 2, description: labels?.allUsers?.[languageObj?.id] },
                ];
                setSelectOptions(selectOptionsLocal);

                response = setErroDefault({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const setDateInControl = ({
        date = {},
        registerDate = {},
        processType_ = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            //#region old code
            // let dateTime = '';
            // const dateFormat = {
            //     date: languageObj?.id === 'en' ? reactTempusDominus?.formatDatemdy : reactTempusDominus?.formatDatedmy,
            //     time: languageObj?.id === 'en' ? 24 : 12,
            // };

            // if (!isUndNullEmpNew({ data: registerDate, subMethod: currentMethod })?.result) {
            //     dateTime = setDateTimeFormatGlobal({
            //         date: registerDate,
            //         type: dateFormat?.date,
            //         format: dateFormat?.time,
            //         addTime: false,
            //         withSeconds: false,
            //         subMethod: currentMethod
            //     })?.result;
            // } else {
            //     dateTime = setDateTimeFormatGlobal({
            //         date: date,
            //         type: dateFormat?.date,
            //         format: dateFormat?.time,
            //         addTime: false,
            //         withSeconds: false,
            //         subMethod: currentMethod
            //     })?.result;
            // }

            // dateTime = dateTime.replace(' -', '').toUpperCase();
            // $(`#${controls?.pickers?.registerDate?.id}`).val(dateTime);
            //#endregion old code

            let dateTime = '';
            const dateFormat = {
                date: languageObj?.format?.date?.f1,
                time: languageObj?.format?.time?.type
            };

            //#region old code
            // if (registerDate) {
            //     dateTime = setDateTimeFormatGlobal({
            //         date: registerDate,
            //         type: dateFormat?.date,
            //         format: dateFormat?.time,
            //         addTime: false,
            //         withSeconds: false,
            //         subMethod: currentMethod
            //     })?.result;
            // } else if (date) {
            //     dateTime = setDateTimeFormatGlobal({
            //         date: date,
            //         type: dateFormat?.date,
            //         format: dateFormat?.time,
            //         addTime: false,
            //         withSeconds: false,
            //         subMethod: currentMethod
            //     })?.result;
            // }
            //#endregion old code

            dateTime = setDateTimeFormatGlobal({
                date: registerDate || date,
                type: dateFormat?.date,
                format: dateFormat?.time,
                addTime: false,
                withSeconds: false,
                subMethod: currentMethod
            })?.result;

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${controls?.pickers?.registerDate?.id}`)?.datetimepicker('options', {
                date: dateTime,
                default: false,
                timepicker: true,
                format: dateTimeFormat,
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setErroDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErroDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                rate: '',
                register: '',
                applyTo: '',
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    useEffect(() => {
        isMount.current = true;
        setData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static'
            onHide={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalClose' })}
            show={showModal}
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='rateLogo' src={images?.rateLogo} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.rate?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${type === 0 ? 'badge-info' : 'badge-warning text-dark'}`}
                            style={settings?.html?.badges?.micro}>
                            {type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => type === 0 ? addRate({ e: e, subMethod: 'onSubmit - form', }) : editRate({ e: e, subMethod: 'onSubmit - form', })}>
                <Modal.Body className='px-4 pt-2'>
                    {/* Rate Input */}
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.rate?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon text-right'
                                title={labels?.rate?.[languageObj?.id]}
                                value={rate?.rate !== undefined && rate?.rate !== null ? rate?.rate : 0.00}
                                onFocus={() => setErrors(prev => ({ ...prev, rate: '' }))}
                                onChange={(e) => setFormValue({ key: dbFields?.rate, value: validateDecimals(e), subMethod: 'rateInput', })}
                                placeholder={labels?.rate?.[languageObj?.id]}
                                disabled={process?.showLoading} />
                        </div>
                        {errors?.rate && <div className={settings?.html?.errorText}>{HtmlParser(errors?.rate || '')}</div>}
                    </div>

                    {/* Date Input */}
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.dateTime?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'
                            id={controls?.pickers?.registerDate?.id}
                            data-target-input='nearest'
                            data-target={`#${controls?.pickers?.registerDate?.id}`}
                            data-toggle='datetimepicker'>
                            <i className={`${settings?.icons?.faFa?.calendar} position-absolute input-icon-left`} />
                            <input id={controls?.inputs?.registerDate?.id}
                                type='text'
                                className='form-control border-0 shadow-sm form-input-icon datetimepicker-input'
                                onFocus={() => setErrors(prev => ({ ...prev, register: '' }))}
                                data-target={`#${controls?.pickers?.registerDate?.id}`}
                                disabled={process?.showLoading} />
                        </div>
                        {errors?.register && <div className={settings?.html?.errorText}>{HtmlParser(errors?.register || '')}</div>}
                    </div>

                    {/* Select ApplyTo */}
                    {type === 0 ? (
                        <div className='form-group mb-4'>
                            <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                {labels?.applyTo?.[languageObj?.id]}
                            </label>
                            <div className='position-relative'>
                                <i className={`${icons?.fasFa?.toggleOn} position-absolute input-icon-left`} />
                                {showModal ? (
                                    <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                        value={applyTo || 0}
                                        onChange={(e) => changeApplyToValue({ applyTo: e.target.value, subMethod: 'selectApplyTo', })}
                                        onFocus={() => setErrors(prev => ({ ...prev, applyTo: '' }))}
                                        disabled={process?.showLoading}>
                                        {selectOptions?.length > 0 ? (
                                            selectOptions.map((detail) => (
                                                <option key={detail?.id} value={detail?.id}>{detail?.description}</option>
                                            ))
                                        ) : null}
                                    </select>
                                ) : null}
                            </div>
                            {errors?.applyTo && <div className={settings?.html?.errorText}>{HtmlParser(errors?.applyTo || '')}</div>}
                        </div>
                    ) : null}
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalFooterClose', })}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    );
}